// extracted by mini-css-extract-plugin
export default {"wrap":"AG-z","fullWidth":"BG-z","hideOnDesktop":"CG-z","content":"DG-z","hasOpenedNav":"EG-z","crumbsList":"FG-z","dropdownsWrap":"GG-z"};